import maxBy from "lodash/maxBy";
import moment, { Moment } from "moment";
import { ISO_DATE_FORMAT, utc } from "PFCore/helpers/date";
import { Calendar } from "PFTypes";
import { useCallback } from "react";

type UseWorkingDayCheck = {
  calendars: Record<string, Calendar>;
};

type UseWorkingDayCheckReturn = {
  isWorkingDayCheck: (date: Moment) => boolean;
};

export const useWorkingDayCheck = ({ calendars }: UseWorkingDayCheck): UseWorkingDayCheckReturn => {
  const getCalendarForDate = useCallback(
    (date: Moment) => {
      const calendarKey = maxBy(
        Object.keys(calendars || []).filter(
          (startDate) => utc(startDate).unix() <= utc(date.format(ISO_DATE_FORMAT)).unix()
        ),
        (startDate) => moment(startDate).unix()
      );
      return calendarKey && calendars[calendarKey];
    },
    [calendars]
  );

  const isWorkingDayCheck = useCallback(
    (date: Moment) => {
      const calendar = getCalendarForDate(date);

      if (!calendar) {
        return true;
      }

      const exception = calendar.exceptionDays.find((day) => date.format(ISO_DATE_FORMAT) === day.date);

      if (exception) {
        return exception.working;
      }

      return calendar.nominalDays.find((day) => day.wday === utc(date).day())?.working || false;
    },
    [getCalendarForDate]
  );
  return {
    isWorkingDayCheck
  };
};
